import { render, staticRenderFns } from "./modalStockBajo.vue?vue&type=template&id=6ffaa67c&scoped=true&"
import script from "./modalStockBajo.vue?vue&type=script&lang=js&"
export * from "./modalStockBajo.vue?vue&type=script&lang=js&"
import style0 from "./modalStockBajo.vue?vue&type=style&index=0&id=6ffaa67c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffaa67c",
  null
  
)

export default component.exports